import { useColorScheme } from 'react-native';

import type { ThemeName } from '../types';

import { useThemeContext } from './useThemeContext';

const useThemeName = () => {
  const { getThemeName } = useThemeContext();
  // @ts-expect-error We are not expecting the useColorScheme hook to anything besides 'light' or 'dark'
  const colorScheme: ThemeName = useColorScheme();

  return getThemeName?.() || colorScheme;
};

export default useThemeName;
